var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import archiveAsset from '../../requests/asset/archiveAsset';
import Signals from '../../signals/Signals';
/**
 *
 */
var ArchiveAssetCommand = /** @class */ (function (_super) {
    __extends(ArchiveAssetCommand, _super);
    function ArchiveAssetCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param reason
     * @param organisationModel OrganisationModel
     * @param assetModel AssetModel
     * @param assetCollection AssetCollection
     * @param intl
     * @return {Promise<T | never>}
     */
    ArchiveAssetCommand.prototype.execute = function (reason, organisationModel, assetModel, assetCollection, intl) {
        this.assetCollection = assetCollection;
        this.assetModel = assetModel;
        this.intl = intl;
        return archiveAsset(organisationModel.id, assetModel.getMetricsDbId(), reason).then(this.then);
    };
    /**
     *
     * @param response
     */
    ArchiveAssetCommand.prototype.then = function (response) {
        this.assetModel.isArchived = true;
        this.assetCollection.remove(this.assetModel);
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'asset.archived.success' }, { assetId: this.assetModel.id }), 'dark', true);
    };
    return ArchiveAssetCommand;
}(Command));
export default ArchiveAssetCommand;
